import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index-lintable.css'; // Using lint-free CSS instead of index.css

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
